import { jsxs, jsx } from "react/jsx-runtime";
const IconHashSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M20 14h-4.216l.445-4H20a1 1 0 1 0 0-2h-3.55l.544-4.89a1.001 1.001 0 0 0-.884-1.104 1.014 1.014 0 0 0-1.104.884L14.438 8h-3.987l.543-4.89a1.001 1.001 0 0 0-.884-1.104c-.536-.05-1.044.335-1.104.884L8.438 8H4a1 1 0 1 0 0 2h4.216l-.445 4H4a1 1 0 1 0 0 2h3.55l-.544 4.89a1.001 1.001 0 0 0 1.988.22L9.562 16h3.987l-.543 4.89a1.001 1.001 0 0 0 1.988.22l.568-5.11H20a1 1 0 1 0 0-2ZM9.784 14l.445-4h3.987l-.445 4H9.784Z" })
    ]
  }
);
export {
  IconHashSvg
};
